import { FileType, ResourceType } from "../../../../interfaces/general";

export interface OverwriteProps {
    files: FileType[];
    onClose: () => void;
    onSubmit: (action: ActionEnum, doForAll: boolean, id: string | null) => void;
    status: boolean;
    currentData: ResourceType[];
}

export enum ActionEnum {
    KEEP,
    REPLACE
}
